import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LocalContextProvider } from './context/LocalContext';
import { RedirectProvider, useRedirect } from './context/RedirectContext';
import SitePopupModal from './components/SitePopupModal/SitePopupModal';
import { SiteProvider } from './context/SiteContext';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/Home/Home';
import AboutAndTestimonials from './components/AboutAndTestimonials/AboutAndTestimonials';
import Contact from './components/Contact/Contact';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import Terms from './components/Terms/Terms';
import Disclaimer from './components/Disclaimer/Disclaimer';
import Refund from './components/Refund/Refund';
import ExpertHelpSection from './components/ExpertHelpSection/ExpertHelpSection';
import FindLove from './components/FindLove/FindLove';
import LoginModal from './components/Auth/LoginModal';
import SignupModal from './components/Auth/SignupModal';
import Notification from './components/container/Notification';
import RedirectEmbed from './pages/RedirectEmbed';

function AppShell() {
  const { hideSiteChrome } = useRedirect();

  return (
    <div className="app">
      {!hideSiteChrome && <Header />}
      <main className={hideSiteChrome ? 'main-content--redirect-embed' : undefined}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutAndTestimonials />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/expert-help" element={<ExpertHelpSection />} />
          <Route path="/find-love" element={<FindLove />} />
          <Route path="/:slug" element={<RedirectEmbed />} />
        </Routes>
      </main>
      {!hideSiteChrome && <Footer />}
      <LoginModal />
      <SignupModal />
      <Notification />
    </div>
  );
}

function App() {
  return (
    <SiteProvider>
      <LocalContextProvider>
        <Router>
          <RedirectProvider>
            <SitePopupModal />
            <AppShell />
          </RedirectProvider>
        </Router>
      </LocalContextProvider>
    </SiteProvider>
  );
}

export default App;
